module.exports = __webpack_public_path__ + "img/table.106d45b4.png";